<script lang="ts">
	import BlockRenderer from '@comp/BlockRenderer.svelte';
	import { type ContentPageData } from './ContentPageQuery';
	import SubMenu from '@comp/SubMenu.svelte';
	import type { EmployeeListBlock } from '@blocks/employeeList/EmployeeListBlockQuery';
	import { ID_TO_BLOCK } from '@blocks/AllBlocks';
	import type { DescriptionBlockType } from '@blocks/description/DescriptionBlockQuery';
	import { PathUtils } from '@core/tools/PathUtils';
	import { untrack } from 'svelte';

	const { data }: { data: ContentPageData } = $props();

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const HASH_SECTIONS: Record<
		string,
		(section: any) => { title: string; hash: string } | undefined
	> = {
		// Define blocks that should be included in the sub menu
		description: (section: DescriptionBlockType) => {
			section.hash = PathUtils.slugify(section.headline);
			if (!section.showInSubmenu) return undefined;
			return { title: section.headline, hash: section.hash };
		},
		employee_list: (section: EmployeeListBlock) => {
			section.hash = PathUtils.slugify(section.headline);
			return { title: section.headline, hash: section.hash };
		}
	};

	let targets: { title: string; hash: string }[] = $state([]);
	function updateSubmenu() {
		targets = [];
		data.content.forEach((section) => {
			if (HASH_SECTIONS[section._modelApiKey]) {
				untrack(() => {
					const target = HASH_SECTIONS[section._modelApiKey](section);
					if (target) targets.push(target);
				});
			}
		});
	}

	$effect(() => {
		updateSubmenu();
	});
</script>

<section class="headline">
	<h1 class="text:headline-large">{data.headline}</h1>
</section>

<SubMenu {targets} />

<div class="blocks">
	<BlockRenderer sections={data.content} sectionMap={ID_TO_BLOCK} caller="content" />
</div>

<style lang="scss">
	section {
		@include layoutBlockGrid;
	}

	.headline {
		padding-bottom: 94px;

		h1 {
			padding-top: 47px;
			grid-column: 1 / span 8;
			padding-bottom: 40px;
			text-wrap: balance;
		}

		@include md {
			h1 {
				padding-top: 73px;
			}
		}
	}
</style>
